import React, { PropsWithChildren, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface ScrollableProps extends PropsWithChildren {
  orientation?: "vertical" | "horizontal";
  className?: string;
  contentClassName?: string;
  noScrollbar?: boolean;
}

const SCROLLABLE_STYLES = {
  vertical: "overflow-y-auto",
  horizontal: "overflow-x-auto",
} as const;

export const SupScrollable = forwardRef<HTMLDivElement, ScrollableProps>(function ScrollableConponent(
  { className, contentClassName, noScrollbar = false, orientation = "vertical", children },
  ref
) {
  return (
    <div ref={ref} className={twMerge("sup-scrollable-container", noScrollbar && "no-scrollbar", SCROLLABLE_STYLES[orientation], className)}>
      <div className={twMerge("sup-scrollable-content", contentClassName)}>{children}</div>
    </div>
  );
});
